import { IUser } from "./types";
import {
  cleanUserPreferenceLocalStorage,
  getUserPreferenceLocalStorage,
  setAccessTokenLocalStorage,
  getAccessTokenLocalStorage,
  setUserAuthLocalStorage,
  getUserAuthLocalStorage,
  handleUserLogOut,
  setUserPreferenceLocalStorage,
} from "./utils";
import { getDecryptedCredentials, clearEncryptedCredentials, hasStoredCredentials } from "../utils/cryptoUtils";
import { LoginRequest } from "../services/UserAuthService";

export function IsAuthenticated(): boolean {
  let token = getAccessTokenLocalStorage();
  if (
    variableIsDiferentNullAndUndefined(token) &&
    token !== ""
  ) {
    return true;
  }
  return false;
}

export function variableIsDiferentNullAndUndefined(value: any) {
  return value !== undefined && value !== null;
}

export function handleDisconnectedUserAux({
  data,
  userAuthenticated,
  userIsAuthenticated,
  setUser,
  setUserAuthenticated,
  user,
  userPreference,
}) {
  handleDisconnectedUserPreRequestAux({
    data,
    userAuthenticated,
    setUserAuthenticated,
    user,
    userPreference,
  });
  if (
    Number(data?.Code) === 401 &&
    IsAuthenticated() === true &&
    (userAuthenticated === true || userIsAuthenticated === true)
  ) {
    handleUserLogOut();
    setUser(null);
    setUserAuthenticated(false);
  }
}

export function handleDisconnectedUserPreRequestAux(objParams) {
  if (
    (objParams.data === undefined || objParams.data === null) &&
    variableIsDiferentNullAndUndefined(objParams.user)
  ) {
    setUserAuthLocalStorage(objParams.user);
    if (objParams.user?.token) {
      setAccessTokenLocalStorage(objParams.user?.token);
    }
    setUserPreferenceLocalStorage(objParams.userPreference, objParams.user);
    if (IsAuthenticated() && !objParams.userAuthenticated) {
      objParams.setUserAuthenticated(true);
    }
  }
}
export function authHeaders(token: string, isForm: boolean) {
  let contentType =
    isForm === true ? "application/x-www-form-urlencoded" : "application/json";
  return {
    Authorization: "Bearer " + token,
    "Content-Type": contentType,
    Accept: "application/json",
  };
}
export function validUserIsConected(user: IUser | null): boolean {
  return (
    user !== null && user !== undefined && user?.username !== null && user?.username !== undefined && user?.username !== ""
  );
}
export async function checkUserIsLogged(
  setUser,
  userAuthenticated,
  setUserAuthenticated,
  setIsAutoLoginLoading
) {
  const tempUser = getUserPreferenceLocalStorage();
  const temptoken = getAccessTokenLocalStorage();
  const userStorage = getUserAuthLocalStorage();
  
  handleTokenCheckUserIsLogged(tempUser, temptoken);
  
  
  if (validUserIsConected(userStorage) && temptoken) {
    handleCheckUserIsLogged(
      userStorage,
      setUser,
      userAuthenticated,
      setUserAuthenticated
    );
  } else {
  
    await handleAutoLoginCheck(setUser, userAuthenticated, setUserAuthenticated, setIsAutoLoginLoading);
  }
}

export async function handleAutoLoginCheck(setUser, userAuthenticated, setUserAuthenticated, setIsAutoLoginLoading) {
  if (hasStoredCredentials()) {
    const credentials = getDecryptedCredentials();
    
    if (credentials && credentials.rememberLogin) {
      setIsAutoLoginLoading(true); // Inicia o loading do autologin
      try {
        const response = await LoginRequest(
          credentials.username,
          credentials.password,
          credentials.countryId,
          credentials.language
        );
        
        if (response && response.access_token) {
          const payload: IUser = {
            username: response.userName,
            rememberLogin: credentials.rememberLogin,
            tosAgree: credentials.tosAgree,
          };
          
          setAccessTokenLocalStorage(response.access_token);
          setUserAuthLocalStorage(payload);
          setUser(payload);
          setUserAuthenticated(true);
          
          setIsAutoLoginLoading(false); 
          return true;
        } else {
          clearEncryptedCredentials();
        }
      } catch (error) {
        clearEncryptedCredentials();
      } finally {
        setIsAutoLoginLoading(false); 
      }
    }
  }
  

  handleCheckUserIsNotLogged(userAuthenticated, setUser, setUserAuthenticated);
  return false;
}
export function handleTokenCheckUserIsLogged(tempUser, temptoken) {
  if (tempUser && temptoken === null) {
    if (tempUser.rememberLogin === false) {
      cleanUserPreferenceLocalStorage();
    }
 
  }
}
export function handleCheckUserIsNotLogged(
  userAuthenticated,
  setUser,
  setUserAuthenticated
) {
  if (!IsAuthenticated() && userAuthenticated === true) {
    setUser(null);
    setUserAuthenticated(false);
  }
}
export function handleCheckUserIsLogged(
  userStorage,
  setUser,
  userAuthenticated,
  setUserAuthenticated
) {
  setUser(userStorage);
  if (IsAuthenticated() && !userAuthenticated) {
    setUserAuthenticated(true);
  }
} 